import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Instagram, MapPin, Phone, Mail } from 'lucide-react';
import { SERVICES, INDUSTRIES, CONTACT } from '../../data/siteData';

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#0A192F] text-white">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
        <div className="lg:col-span-2">
          <div className="text-3xl font-extrabold tracking-tight font-heading mb-4">
            <span className="text-white">Work</span><span className="text-[#4DA3FF]">Lynx</span>
          </div>
          <p className="text-slate-400 text-sm leading-relaxed max-w-sm">
            India&apos;s workforce &amp; operations partner for scale. Building reliable workforce
            infrastructure for modern businesses — from deployment and hiring to AI data and robotics operations.
          </p>
          <div className="flex gap-3 mt-6">
            <a href={CONTACT.linkedin} target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin" aria-label="LinkedIn"
              className="w-10 h-10 rounded-md bg-white/5 border border-white/10 flex items-center justify-center hover:bg-[#0066CC] transition-colors">
              <Linkedin className="w-4 h-4" />
            </a>
            <a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" aria-label="Instagram"
              className="w-10 h-10 rounded-md bg-white/5 border border-white/10 flex items-center justify-center hover:bg-[#0066CC] transition-colors">
              <Instagram className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.15em] text-slate-500 mb-5">Services</h4>
          <ul className="space-y-2.5">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link to={`/services/${s.slug}`} data-testid={`footer-service-${s.slug}`} className="text-sm text-slate-300 hover:text-white transition-colors">{s.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.15em] text-slate-500 mb-5">Company</h4>
          <ul className="space-y-2.5">
            <li><Link to="/#about" className="text-sm text-slate-300 hover:text-white transition-colors">About Us</Link></li>
            <li><Link to="/#industries" className="text-sm text-slate-300 hover:text-white transition-colors">Industries</Link></li>
            <li><Link to="/#success-stories" className="text-sm text-slate-300 hover:text-white transition-colors">Success Stories</Link></li>
            <li><Link to="/#faq" className="text-sm text-slate-300 hover:text-white transition-colors">FAQ</Link></li>
            <li><Link to="/#contact" className="text-sm text-slate-300 hover:text-white transition-colors">Contact</Link></li>
            <li><Link to="/privacy-policy" data-testid="footer-privacy" className="text-sm text-slate-300 hover:text-white transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms" data-testid="footer-terms" className="text-sm text-slate-300 hover:text-white transition-colors">Terms &amp; Conditions</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.15em] text-slate-500 mb-5">Contact</h4>
          <ul className="space-y-4 text-sm text-slate-300">
            <li className="flex gap-3"><MapPin className="w-4 h-4 mt-0.5 shrink-0 text-[#4DA3FF]" /><span><strong className="text-white block text-xs uppercase tracking-wider mb-1">Corporate Office</strong>{CONTACT.corporateOffice}</span></li>
            <li className="flex gap-3"><MapPin className="w-4 h-4 mt-0.5 shrink-0 text-[#4DA3FF]" /><span><strong className="text-white block text-xs uppercase tracking-wider mb-1">Operating Office</strong>{CONTACT.operatingOffice}</span></li>
            <li className="flex gap-3"><Phone className="w-4 h-4 mt-0.5 shrink-0 text-[#4DA3FF]" /><a href={`tel:${CONTACT.phoneRaw}`} className="hover:text-white">{CONTACT.phone}</a></li>
            <li className="flex gap-3"><Mail className="w-4 h-4 mt-0.5 shrink-0 text-[#4DA3FF]" />
              <span className="space-y-1">
                <a href={`mailto:${CONTACT.email}`} className="block hover:text-white">{CONTACT.email}</a>
                <a href={`mailto:${CONTACT.clientsEmail}`} className="block hover:text-white">{CONTACT.clientsEmail}</a>
              </span>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-xs text-slate-500">© {new Date().getFullYear()} WorkLynx. All rights reserved.</p>
        <p className="text-xs text-slate-500">Industries: {INDUSTRIES.slice(0, 5).map((i) => i.name).join(' · ')}</p>
      </div>
    </div>
  </footer>
);
